import { calculateMotorLoadDifferentFrequency, calculateMotorLoadFrequency, fetchSchematicData, fetchSetDepth, fetchUpdatedSchematicEquipmentData, saveMainReportDataLake, saveProjectData, saveSchematicData, setAIEnabled, setProjectStatus, setSchematicEquipmentData, setSchematicMiscSetDepthValue, setSchematicOtherData, setSchematicSetDepthTypeValue } from "../../store/calculation/calculationSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks/StoreHooks";
import { useParams } from "react-router-dom";
import { setGlobalTemplate, updateSelectedProject } from "../../store/dashboard/ProjectsSlice";
import { fetchAllProjects, resetProjectDetails } from "../../store/calculation/calculation-input/ProjectTabSlice";
import { resetFluidTab } from "../../store/calculation/calculation-input/FluidSlice";
import { resetWellDetails } from "../../store/calculation/calculation-input/WellSlice";
import { resetOthersTab } from "../../store/calculation/calculation-input/OthersSlice";
import { resetTubingTab } from "../../store/calculation/calculation-input/TubingSlice";
import { resetGascalculations } from "../../store/calculation/calculation-output/gasCalculaionSlice";
import { resetBasicCalculations } from "../../store/calculation/calculation-output/basicCalculationSlice";
import { resetPumpOutput } from "../../store/calculation/calculation-output/pumpSlice";
import { resetCableOutput } from "../../store/calculation/calculation-output/cableSlice";
import { resetProtectorOutput } from "../../store/calculation/calculation-output/protectorSlice";
import { resetMotorOutput } from "../../store/calculation/calculation-output/motorSlice";
import { resetSurfaceEquipmentOutput } from "../../store/calculation/calculation-output/surfaceEquipmentSlice";
import { setTemplate } from "../../store/dashboard/CreateProjectSlice";

const useCalculationFacade = () => {
    const dispatch = useAppDispatch();
    const { ID, caseID } = useParams();
    const { selectedProject } = useAppSelector(state => state?.myProjects);

    const loadProjectDetails = async (payload1: any) => {
        const projectId = ID?.split("projectID=")?.[1];
        const caseId = caseID?.split("caseID=")?.[1];
        const templateId = ID?.split("templateID=")?.[1];
        const selectproject = {
            projectID: projectId,
            projectName: selectedProject?.projectName || ""
        }
        const payload = {
            id: (caseId !== projectId && caseId !== undefined) ? caseId : projectId,
            templateid: templateId ?? ""
        }
        await dispatch(fetchAllProjects(payload1));
        dispatch(resetProjectDetails());
        dispatch(resetTubingTab());
        dispatch(resetWellDetails());
        dispatch(resetFluidTab());
        dispatch(resetOthersTab());
        dispatch(resetGascalculations());
        dispatch(resetBasicCalculations());
        dispatch(resetPumpOutput());
        dispatch(resetCableOutput());
        dispatch(resetMotorOutput());
        dispatch(resetProtectorOutput());
        dispatch(resetSurfaceEquipmentOutput());
        dispatch(setGlobalTemplate(""));
        dispatch(updateSelectedProject(selectproject));
        if (projectId || caseId) {
            const id = (caseId !== projectId && caseId !== undefined) ? caseId : projectId
            dispatch({ type: "calculations/fetchSchematicData", payload: id });
        }
        fetchCalculations(payload);
    };

    const loadTemplateCalculations = async () => {
        const templateId = ID?.split("templateID=")?.[1];
        dispatch(resetProjectDetails());
        dispatch(resetTubingTab());
        dispatch(resetWellDetails());
        dispatch(resetFluidTab());
        dispatch(resetOthersTab());
        dispatch(resetGascalculations());
        dispatch(resetBasicCalculations());
        dispatch(resetPumpOutput());
        dispatch(resetCableOutput());
        dispatch(resetMotorOutput());
        dispatch(resetProtectorOutput());
        dispatch(resetSurfaceEquipmentOutput());
        dispatch(setGlobalTemplate(templateId));
        dispatch(setTemplate(templateId));
        dispatch(updateSelectedProject({}));
        if (templateId) {
            fetchTemplateCalculations(templateId ?? "");
        }
    };

    const fetchCalculations = (payload: any) => {
        return dispatch({ type: "calculations/getProjectDetails", payload: { id: payload?.id ?? "", templateid: payload?.templateid ?? "" } });
    };

    const fetchTemplateCalculations = (templateId: string) => {
        return dispatch({ type: "calculations/fetchTemplateCalculations", payload: templateId });
    };

    const fetchCalculatedSetDepth = () => {
        return dispatch(fetchSetDepth());
    };

    const updateSchematicData = (payload: any) => {
        return dispatch(setSchematicEquipmentData(payload));
    };

    const updateAIEnabled = (payload: any) => {
        return dispatch(setAIEnabled(payload));
      };

    const updateProjectStatus = (status: number) => {
        return dispatch(setProjectStatus(status));
    };

    const updateSchematicEquipmentData = () => {
        return dispatch(fetchUpdatedSchematicEquipmentData());
    };

    const updateMotorLoadDifferentFrequency = (payload: any) => {
        return dispatch(calculateMotorLoadDifferentFrequency(payload));
    };

    const updateMotorLoadFrequency = () => {
        return dispatch(calculateMotorLoadFrequency())
    };

    const updateSchematicMiscSetDepthValue = (payload: any) => {
        return dispatch(setSchematicMiscSetDepthValue(payload));
    };

    const updateSettingDepthReference = (value: number) => {
        return dispatch(setSchematicSetDepthTypeValue(value));
    };

    const updateSchematicOtherData = (payload: any) => {
        return dispatch(setSchematicOtherData(payload));
    }
    const SaveProject = async () => {

        if (window.location.pathname.includes('templateID')) {
            return dispatch(saveProjectData());
        }
        else {
            dispatch(saveSchematicData());
            dispatch(saveMainReportDataLake());
            return dispatch(saveProjectData());
        }
    };

    return {
        loadProjectDetails,
        fetchCalculatedSetDepth,
        updateSchematicData,
        updateSchematicEquipmentData,
        updateMotorLoadDifferentFrequency,
        updateMotorLoadFrequency,
        updateSchematicMiscSetDepthValue,
        updateSettingDepthReference,
        updateSchematicOtherData,
        loadTemplateCalculations,
        SaveProject,
        updateAIEnabled,
        updateProjectStatus
    };
};

export default useCalculationFacade;
